<template>
  <div class="auth__bg">
    <div class="container auth__container pt-5">
      <div class="columns is-centered">
        <div class="column is-one-third card login__card">
          <div class="login__card-content card-content">
            <img
              class="login__card-content__logo"
              src="../assets/cladify_logo_lg.png"
              alt="cladify logo"/>

            <v-fade-transition mode="out-in">
              <p :key="loginPrompt" class="my-5">
                {{ loginPrompt }}
              </p>
            </v-fade-transition> 
            
            <v-fade-transition mode="out-in">
              <div class="column is-8" v-if="!withEmail">
                <auth-social-sign-in
                  class="is-fullwidth"
                  @success="authSuccess">
                </auth-social-sign-in>
                <button
                  @click="withEmail = true" 
                  class="button is-primary mt-3 is-fullwidth">
                  <span class="icon">
                    <i class="far fa-envelope"></i>
                  </span>
                  <span>Log in with Email</span>
                </button>
              </div>

              <v-form 
                class="column is-9" 
                :valid.sync="valid" 
                v-else>
                <div class="field">
                  <label class="label">Email*</label>
                  <v-text-field
                    required
                    placeholder="Enter your email"
                    :rules="emailRules" 
                    v-model="loginInfo.email"/>
                </div>
                <div class="field">
                  <label class="label">Password*</label>
                  <v-text-field
                    required
                    type="password"
                    placeholder="Enter your password" 
                    v-model="loginInfo.password"/>
                </div>
                <button 
                  :disabled="!valid || !loginInfo.email || !loginInfo.password || loggingIn"
                  @click.prevent="login()"
                  :class="{ 'is-loading': loggingIn }"
                  class="button is-primary is-fullwidth mt-5">
                  Log In
                </button>
                <a 
                  class="help mt-3 has-text-centered"
                  @click="withEmail = false">
                  Log in with Google instead
                </a>
              </v-form>
            </v-fade-transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import AuthSocialSignIn from '@/components/user/AuthSocialSignIn'

import { mapState, mapActions, mapMutations } from 'vuex'
import helpers from '@/helpers'

export default {
  components: { VTextField, VForm, VFadeTransition, AuthSocialSignIn },
  data() {
    return {
      withEmail: false,
      loginInfo: {
        email: null,
        password: null,
        code: null
      },
      emailRules: [helpers.validateEmail],
      valid: false,
      loggingIn: false
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    loginPrompt({ withEmail }) {
      return withEmail ? 'Please enter your credentials' : 
        'Please log in with your Google Account'
    }
  },
  methods: {
    ...mapActions("auth", ["authLogin"]),
    ...mapMutations("auth", ["setChangingPassword"]),
    authSuccess(authResp) {
      authResp.redirect_uri = window.location.origin;
      this.authLogin(authResp)
        .then(() => this.$router.push({ name: 'Home' }));
    },
    login() {
      this.loggingIn = true;

      this.authLogin(this.loginInfo).then(
        resp => {
          this.$router.push({ name: 'Home' });
          if (resp.data.sign_in_count == 1) {
            this.setChangingPassword(true);
          }
          this.loggingIn = false;
        }
      ).catch(() => this.loggingIn = false);
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  &__bg {
    background-image: url('../assets/login_page_bg.jpg');
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
  }
  &__container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.login {
  &__card {
    background: rgba(255, 255, 255, .95);
  }
  &__card-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__logo {
      width: 200px;
      margin-bottom: 1em;
      height: auto;
    }
  }
}
</style>
